module.exports = __webpack_public_path__ + "stylesheets/landing-new-bottom_e19648dd9cbe847f71d8e7c715eaa57d.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing/landing-new-bottom.less
// module id = LT3T
// module chunks = 154